export const favoriteFilterKeys = {
	currencies: 'favAdmSARV2Currencies',
	productIds: 'favAdmSARV2ProductIds',
	platformIds: 'favAdmSARV2PlatformIds',
	whoEarnedIds: 'favAdmSARV2WhoEarnedIds',
	referredAffiliateIds: 'favAdmSARV2ReferredAffiliateIds',
	commissionLevels: 'favAdmSARV2CommissionLevels',
	deals: 'favAdmSARV2Deals',
	playerIds: 'favAdmSARV2PlayerIds',
	brands: 'favAdmSARV2Brands',
	geo: 'favAdmSARV2Geo',
}

export const reportStorageProps = {
  type: 'sub-affiliate-report-v2',
  target: 'filters',
  tableSettingsTarget: 'table-settings',
  savedReportTarget: 'sub-affiliate-report-v2-settings',
  savedReportFavoritesTarget: 'sub-affiliate-report-v2-favorites',
  savedReportDefaultTarget: 'sub-affiliate-report-v2-default',
  exceptions: ['group_by', 'period', 'sent_from', 'sent_to'],
  exceptionsIds: ['brands', 'currencies', 'geo'],
  exceptionsStr: ['players'],
  maxFavoriteReports: 10,
}
